var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { inject, PLATFORM_ID, RendererFactory2, } from "@angular/core";
import { ActivatedRoute } from "@topyourthree/activated-route";
import { Auth } from "@topyourthree/auth";
import { LocalStorage } from "@topyourthree/local-storage";
import { UI_CONFIG } from "@topyourthree/ui/ui.config";
import { UntilDestroy } from "@ngneat/until-destroy";
import { combineLatest, of, Subscription, } from "rxjs";
import { shareReplay, switchMap } from "rxjs/operators";
import { ShellConfig } from "../../app/app-shell/shell-config.service";
import * as i0 from "@angular/core";
let UiStateService = class UiStateService {
    constructor() {
        this.document = inject(DOCUMENT);
        this.localStorage = inject(LocalStorage);
        this.platformId = inject(PLATFORM_ID);
        this.renderer = inject(RendererFactory2).createRenderer(null, null);
        this.activatedRoute = inject(ActivatedRoute);
        this.auth = inject(Auth);
        this.shellConfig = inject(ShellConfig);
        this.uiConfig = inject(UI_CONFIG);
        this.subscription = new Subscription();
        if (isPlatformBrowser(this.platformId)) {
            this.sectionHeroSetting$ = combineLatest([
                this.shellConfig.getConfig(this.activatedRoute.activatedRoute),
                this.auth.isLoggedIn(),
                this.localStorage.get("sectionHeroSetting"),
            ]).pipe(switchMap(([config, isLoggedIn, sectionHeroSetting,]) => {
                if (sectionHeroSetting) {
                    return of(sectionHeroSetting);
                }
                return of(false);
            }), shareReplay({ bufferSize: 1, refCount: true }));
        }
    }
    getUiStateSetting() {
        return this.sectionHeroSetting$;
    }
    async setUiStateSetting(uiState) {
        await this.localStorage.set("sectionHeroSetting", uiState);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    applyInitialSectionHero() {
        if (!isPlatformBrowser(this.platformId))
            return;
        try {
            const raw = localStorage.getItem("sectionHeroSetting");
            if (!raw)
                return;
            const parsed = JSON.parse(raw);
            const entry = parsed["logged-out"] || parsed[Object.keys(parsed)[0]];
            if (!entry)
                return;
            const sectionHeroSetting = entry.item;
            const sectionHero = document.querySelector("#sectionHero");
            if (sectionHero) {
                if (sectionHeroSetting === "true") {
                    this.renderer.addClass(sectionHero, "is-open");
                }
                if (sectionHeroSetting === "false") {
                    this.renderer.removeClass(sectionHero, "is-open");
                }
            }
        }
        catch { }
    }
};
UiStateService.ɵfac = function UiStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UiStateService)(); };
UiStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UiStateService, factory: UiStateService.ɵfac, providedIn: "root" });
UiStateService = __decorate([
    UntilDestroy({ className: "UiStateService" }),
    __metadata("design:paramtypes", [])
], UiStateService);
export { UiStateService };
